import { createContext } from "react";

/**
 * Provides a reference to the navbar actions slot so pages can portal
 * their action buttons (e.g. "AI Agent") into the top navbar.
 */
export const NavbarActionsContext = createContext<HTMLElement | null>(null);
